import ReviewAttribute from "../../../../Components/SharedComponent/ReviewAttribute/ReviewAttribute";
import ReviewSummarySectionHeading from "../../../../Components/SharedComponent/ReviewSummarySectionHeading/ReviewSummarySectionHeading";
import { toTitleCase } from "../../../../Utils/stringUtls";

const BulkCardOrderingPortalOverview = ({ data }) => {
  const {
    bulk_card_ordering_portal_would_you_like_c_partner,
    bulk_card_ordering_portal_c_partner_language,
    bulk_card_ordering_portal_c_partner_language_other,
    bulk_card_ordering_portal_url,
  } = data["3_7"];

  const languageValue = [
    ...(bulk_card_ordering_portal_c_partner_language ?? [])
      .filter((l) => l?.length && l !== "other")
      .map(toTitleCase),
    ...(bulk_card_ordering_portal_c_partner_language?.includes("other") &&
    bulk_card_ordering_portal_c_partner_language_other?.length
      ? [`Other (${toTitleCase(bulk_card_ordering_portal_c_partner_language_other)})`]
      : []),
  ].join(", ");

  return (
    <div className="forms-instance" style={{ color: "#111" }}>
      <div i2c-grid="grid grid" className="review-summary-gap">
                <div i2c-grid="12@md">
          <ReviewSummarySectionHeading title="Bulk Card Ordering Portal (C-Partner)" />
        </div>
        <ReviewAttribute
          label="Would you like C-Partner?"
          value={
            bulk_card_ordering_portal_would_you_like_c_partner?.length
              ? toTitleCase(bulk_card_ordering_portal_would_you_like_c_partner)
              : "-"
          }
        />
        <ReviewAttribute
          label="C-Partner Language"
          value={languageValue || "-"}
        />
      </div>
      <div className="divider-bottom mt-16"></div>
    </div>
  );
};
export default BulkCardOrderingPortalOverview;
